import type { TOC } from '@ember/component/template-only';
import ItemCard from './item-card.gts';
import type { Mention } from '../schemas/mention.ts';
import type { Item } from '../schemas/item.ts';

interface ItemsListSignature {
  Args: {
    mentions: Mention[];
  };
}

/** Extracts unique items from mentions (deduplicated by id). */
function uniqueItems(mentions: Mention[]): Item[] {
  if (!mentions) return [];
  const seen = new Set<string>();
  const items: Item[] = [];

  for (const mention of mentions) {
    const item = mention.item;
    if (item && !seen.has(String(item.id))) {
      seen.add(String(item.id));
      items.push(item);
    }
  }

  return items;
}

const ItemsList: TOC<ItemsListSignature> = <template>
  {{#let (uniqueItems @mentions) as |items|}}
    {{#if items.length}}
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {{#each items as |item|}}
          <ItemCard @item={{item}} />
        {{/each}}
      </div>
    {{else}}
      <div class="text-base-content/40 mt-8 text-center text-sm">
        No items extracted yet.
      </div>
    {{/if}}
  {{/let}}
</template>;

export default ItemsList;
